// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  border-radius: 7px !important;
}

.sticky_header {
  position: sticky;
  left: 0;
}

.sticky_row {
  position: sticky;
  bottom: 0;
  z-index: 4;
  margin: 0;
  padding: 0;
}

.sticky_row td {
  margin: 0 !important;
  padding: 7px !important;
}

.sticky_row input,
.sticky_row select {
  background-color: #f5f5f5;
  color: black;
  height: 35px;
  width: 100%;
}

.hide_scrollbar::-webkit-scrollbar,
.table_main_list::-webkit-scrollbar {
  display: none !important;
}

.list_main_container {
  padding: 0 30px 30px 30px !important;
  background-color: white;
  border-top: none;
  border-left: 1px solid lightgray;
  border-right: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  margin-bottom: 120px;
  overflow: scroll;
}

.main_wrapper {
  height: 90vh;
  overflow-y: scroll;
}

.form_main_container {
  max-height: 95vh;
  overflow: scroll;
  padding-bottom: 100px;
}

.table {
  width: auto;
  table-layout: fixed;
  border-collapse: collapse;
  background-color: white;
  border-top-left-radius: 9px !important;
  min-width: 100%;
}

.table th,
.table td {
  border: 1px solid #ccc;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  text-align: center !important;
  vertical-align: middle;
}

#table_form_row td,
#table_form_row td,
#table_form_row td input,
#table_form_row td select {
  font-weight: bold !important;
  color: gray !important;
  background-color: rgb(252, 250, 250);
}

.list_wrapper {
  padding: 20px;
  font-size: 14px;
}

.list_wrapper .row:hover {
  background-color: #f8fafc;
}

.list_wrapper .row .col,
.list_wrapper .row .check_col {
  border-bottom: 1px solid #e7e8ea;
  background-color: transparent;
  color: gray;
}

.switch_btn_div {
  display: flex;
  justify-content: center;
  align-items: center;
}

/*List style for PC */
.table_main_list thead {
  position: sticky;
  top: -11px;
  z-index: 3;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.table_main_list th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #548dff;
  position: sticky;
  left: -12px;
  z-index: 4;
}

.table_main_list th:nth-child(2) {
  border-top: 7px solid #548dff;
  position: sticky;
  left: 58px;
  z-index: 4;
  text-align: left !important;
  cursor: pointer;
}

.table_main_list td:nth-child(1) {
  position: sticky;
  left: -12px;
  z-index: 2;
}

.table_main_list td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.table_main_list td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #548dff !important;
}

.table_main_list #sticky_col0 {
  position: sticky;
  left: 58px;
  z-index: 2;
}

.table_main_list th:last-child {
  width: 60px;
}

.table_main_list th,
.table_main_list td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* List style for Mobile */
.table_main_list_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.table_main_list_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #548dff;
  /* position: sticky;
  left: -2px; */
}

.table_main_list_mobile th:nth-child(2) {
  width: 24;
  border-top: 7px solid #548dff;
  text-align: left !important;
  /* position: sticky;
  left: 67px; */
}

.table_main_list_mobile td:nth-child(1) {
  /* position: sticky;;
  left: -2px;
  z-index: 2; */
}

.table_main_list_mobile #sticky_col0 {
  /* position: sticky;
  left: 67px;
  z-index: 2; */
}

.table_main_list_mobile th:last-child,
.table_main_list_mobile td:last-child {
  width: 60px;
  position: sticky;
  background-color: rgb(245, 241, 241);
}

.table_main_list_mobile th,
.table_main_list_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

.list_img {
  height: 30px;
  width: 30px;
}

.name_sec ._name {
  color: #606175 !important;
  font-size: 16px !important;
  font-weight: 500;
}

.name_sec ._id {
  color: #9a9ca8 !important;
  font-size: 12px !important;
}

.topbar_logo {
  height: 40px;
  width: auto;
}

.topbar_main {
  height: 55px;
  background-color: white;
  border-bottom: 1px solid lightgray;
}

.esearch_wrapper input,
.efilter_wrapper input {
  height: 30px !important;
  width: 20px !important;
  background-color: #fbfcff;
  color: #aaaaaa !important;
  border: none;
  font-size: 12px;
}

.esearch_wrapper input {
  border-right: none !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.efilter_wrapper input {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.esearch_wrapper input:focus,
.efilter_wrapper input:focus {
  background-color: #fbfcff;
  border: none !important;
  color: #aaaaaa;
}

.esearch_wrapper .esearch_span,
.efilter_wrapper .efilter_span {
  height: 30px !important;
  border: none !important;
  background-color: #fbfcff;
  border: none;
}

.esearch_wrapper .esearch_span {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.css-1e6y48t-MuiButtonBase-root-MuiButton-root,
.css-1w1rijm-MuiButtonBase-root-MuiButton-root {
  min-width: 0px;
}

.efilter_wrapper .efilter_span {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.add_event_btn {
  width: 330px !important;
  text-transform: capitalize;
  font-size: 12px !important;
}

.filter_sec .view_type {
  border-left: 1px solid lightgray;
}

.grid_view_row {
  height: 80vh;
  overflow-y: scroll;
}

.grid_view_row::-webkit-scrollbar {
  display: none;
}

.event_tab_container {
  background-color: white;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border: 1px solid lightgray;
}

.css-1a4cg4j-MuiButtonBase-root-MuiTab-root {
  margin-bottom: 7px;
}

.css-8je8zh-MuiTouchRipple-root {
  border-right: 1px solid lightgray;
}

.events_list {
  height: 87vh !important;
  padding-left: 20px;
  padding-right: 20px;
  overflow-y: scroll;
}

.events_list::-webkit-scrollbar {
  display: none;
}

.events_grid_container {
  background-color: white;
  padding: 20px 30px 20px 30px;
  margin-bottom: 150px;
  border-left: 1px solid lightgray;
  border-right: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.css-1uz47yx-MuiPaper-root-MuiCard-root {
  overflow: visible;
}

.event_info_container {
  min-height: 180px;
  height: auto;
  background-color: white;
  border-radius: 15px;
  border: 1px solid lightgray;
}

.apply_border {
  border-right: 1px solid lightgray;
}

.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  background-color: #ddebff;
  color: #579aff;
  width: 40px;
}

.event_details_container1 {
  min-height: 180px;
  height: auto;
}

.event_details_container1 .detail_row1 {
  min-height: 180px;
  height: auto;
}

.detail_row1 .col1_contents,
.detail_row1 .col2_contents,
.detail_row1 .col3_contents {
  border: 1px solid lightgray;
  border-radius: 15px;
  background-color: white;
}

.overview_grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
}

.list_main_wrapper {
  height: 60vh;
  overflow: scroll;
}

.list_main_wrapper::-webkit-scrollbar {
  display: none;
  margin-bottom: 100px;
}

#sticky_col11 {
  width: 180px !important;
}

.custome_badge1 {
  min-height: 20px;
  width: auto;
  border-radius: 30px;
  background-color: #ffefef;
}

.custome_badge2 {
  min-height: 20px;
  width: auto;
  border-radius: 30px;
  background-color: #fff9eb;
}

.custome_badge3 {
  min-height: 20px;
  width: auto;
  border-radius: 30px;
  background-color: #edf5ff;
}

.candidate_details_container {
  height: 80vh;
  height: auto;
  border: 1px solid lightgray;
  border-radius: 15px;
  background-color: white;
}

.candidate_details_container ._input_form {
  padding: 0px 200px 30px 200px;
}

.candidate_main_container {
  height: 87vh;
  padding-bottom: 200px;
  overflow: scroll;
}

.candidate_main_container::-webkit-scrollbar {
  display: none;
}

.other_files_box {
  height: 150px;
  width: 200px;
  border: 1px solid lightgray;
  border-radius: 15px;
}

.candidate_details_sec1 {
  border-bottom: 1px solid lightgray;
}

.scrollable_list_card_wrapper .css-1fua316-MuiPaper-root-MuiCard-root {
  overflow: visible;
}

.scrollable_list_card_wrapper .css-1oitmrd-MuiButtonBase-root-MuiCardActionArea-root {
  min-width: 768px;
}

.scrollable_list_card_wrapper .scrollable_card {
  overflow-x: scroll;
}

.scrollable_list_card_wrapper .scrollable_card::-webkit-scrollbar {
  display: none;
}

.main_container {
  padding: 0px 40px 0px 40px;
}

.blue_theme_pagination .items_per_page_select {
  border: none;
  width: 55px;
}

.blue_theme_pagination .items_per_page_select:focus {
  border: none;
  outline: none;
}

.blue_theme_pagination .items_per_page_select option:hover {
  background-color: #548dff;
  color: white;
}

@media screen and (max-width: 991px) {
  .candidate_details_container ._input_form {
    padding: 0px 50px 20px 50px;
  }
}
@media screen and (max-width: 583px) {
  ._cont1 {
    font-size: 16px;
  }
  ._cont2 {
    font-size: 14px;
  }
  ._cont3 {
    font-size: 12px;
  }
}
@media screen and (max-width: 576px) {
  .pc_display {
    display: none !important;
  }
  .mobile_display {
    display: block !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Assets/components/meetspace/events.scss"],"names":[],"mappings":"AAAA;EAGI,6BAAA;AADJ;;AAMA;EACI,gBAAA;EACA,OAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAHJ;;AAMA;EACI,oBAAA;EACA,uBAAA;AAHJ;;AAOA;;EAEI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAJJ;;AAOA;;EAEI,wBAAA;AAJJ;;AAOA;EACI,oCAAA;EACA,uBAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAAA;EACA,kCAAA;EACA,+BAAA;EACA,gCAAA;EACA,oBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,gBAAA;EACA,qBAAA;AAJJ;;AAQA;EACI,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sCAAA;EACA,eAAA;AALJ;;AAQA;;EAEI,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,sBAAA;AALJ;;AAQA;;;;EAII,4BAAA;EACA,sBAAA;EACA,oCAAA;AALJ;;AAQA;EACI,aAAA;EACA,eAAA;AALJ;;AAQA;EACI,yBAAA;AALJ;;AAQA;;EAEI,gCAAA;EACA,6BAAA;EACA,WAAA;AALJ;;AAQA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AALJ;;AAQA,qBAAA;AACA;EACI,gBAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AALJ;;AAQA;EACI,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AALJ;;AAQA;EACI,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,2BAAA;EACA,eAAA;AALJ;;AAQA;EACI,gBAAA;EACA,WAAA;EACA,UAAA;AALJ;;AAQA;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AALJ;;AAQA;EACI,oCAAA;AALJ;;AASA;EACI,gBAAA;EACA,UAAA;EACA,UAAA;AANJ;;AAUA;EACI,WAAA;AAPJ;;AAUA;;EAEI,YAAA;EACA,eAAA;EACA,sBAAA;AAPJ;;AAWA,0BAAA;AACA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AARJ;;AAYA;EACI,WAAA;EACA,6BAAA;EACA;eAAA;AARJ;;AAYA;EACI,SAAA;EACA,6BAAA;EACA,2BAAA;EACA;eAAA;AARJ;;AAYA;EACI;;eAAA;AAPJ;;AAYA;EACI;;eAAA;AAPJ;;AAaA;;EAEI,WAAA;EACA,gBAAA;EAEA,oCAAA;AAXJ;;AAcA;;EAEI,YAAA;EACA,eAAA;EACA,sBAAA;AAXJ;;AAcA;EACI,YAAA;EACA,WAAA;AAXJ;;AAcA;EACI,yBAAA;EACA,0BAAA;EACA,gBAAA;AAXJ;;AAcA;EACI,yBAAA;EACA,0BAAA;AAXJ;;AAgBA;EACI,YAAA;EACA,WAAA;AAbJ;;AAgBA;EACI,YAAA;EACA,uBAAA;EACA,kCAAA;AAbJ;;AAgBA;;EAEI,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AAbJ;;AAgBA;EACI,6BAAA;EACA,uCAAA;EACA,0CAAA;AAbJ;;AAgBA;EACI,sCAAA;EACA,yCAAA;AAbJ;;AAgBA;;EAEI,yBAAA;EACA,uBAAA;EACA,cAAA;AAbJ;;AAgBA;;EAEI,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAbJ;;AAgBA;EACI,4BAAA;EACA,+BAAA;AAbJ;;AAgBA;;EAEI,cAAA;AAbJ;;AAgBA;EACI,2BAAA;EACA,8BAAA;AAbJ;;AAgBA;EACI,uBAAA;EACA,0BAAA;EACA,0BAAA;AAbJ;;AAgBA;EACI,gCAAA;AAbJ;;AAgBA;EACI,YAAA;EACA,kBAAA;AAbJ;;AAgBA;EACI,aAAA;AAbJ;;AAgBA;EACI,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;AAbJ;;AAiBA;EACI,kBAAA;AAdJ;;AAiBA;EACI,iCAAA;AAdJ;;AAqBA;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAlBJ;;AAqBA;EACI,aAAA;AAlBJ;;AAqBA;EACI,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,gCAAA;EACA,iCAAA;EACA,kCAAA;EACA,+BAAA;EACA,gCAAA;AAlBJ;;AAqBA;EACI,iBAAA;AAlBJ;;AAqBA;EACI,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;AAlBJ;;AAqBA;EACI,iCAAA;AAlBJ;;AAuBA;EACI,yBAAA;EACA,cAAA;EACA,WAAA;AApBJ;;AAuBA;EACI,iBAAA;EACA,YAAA;AApBJ;;AAuBA;EACI,iBAAA;EACA,YAAA;AApBJ;;AAuBA;;;EAGI,2BAAA;EACA,mBAAA;EACA,uBAAA;AApBJ;;AAuBA;EACI,aAAA;EACA,kCAAA;AApBJ;;AAuBA;EACI,YAAA;EACA,gBAAA;AApBJ;;AAuBA;EACI,aAAA;EACA,oBAAA;AApBJ;;AAuBA;EACI,uBAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,YAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;AApBJ;;AAuBA;EACI,6BAAA;AApBJ;;AAuBA;EACI,YAAA;EACA,qBAAA;EACA,gBAAA;AApBJ;;AAuBA;EACI,aAAA;AApBJ;;AAuBA;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;AApBJ;;AAuBA;EACI,kCAAA;AApBJ;;AAuBA;EACI,iBAAA;AApBJ;;AAuBA;EACI,gBAAA;AApBJ;;AAuBA;EACI,kBAAA;AApBJ;;AAuBA;EACI,aAAA;AApBJ;;AAuBA;EACI,0BAAA;AApBJ;;AA0BA;EACI,YAAA;EACA,WAAA;AAvBJ;;AA0BA;EACI,YAAA;EACA,aAAA;AAvBJ;;AA0BA;EACI,yBAAA;EACA,YAAA;AAvBJ;;AA4BA;EACI;IACI,2BAAA;EAzBN;AACF;AA4BA;EACI;IACI,eAAA;EA1BN;EA6BE;IACI,eAAA;EA3BN;EA8BE;IACI,eAAA;EA5BN;AACF;AA+BA;EACI;IACI,wBAAA;EA7BN;EAgCE;IACI,yBAAA;EA9BN;AACF","sourcesContent":[".table-container {\n    // overflow: auto;\n    // max-width: 100%;\n    border-radius: 7px !important;\n    //   box-shadow: 3px 5px 0px #c6c5c5 !important;\n    // overflow: scroll !important;\n}\n\n.sticky_header {\n    position: sticky;\n    left: 0;\n}\n\n.sticky_row {\n    position: sticky;\n    bottom: 0;\n    z-index: 4;\n    margin: 0;\n    padding: 0;\n}\n\n.sticky_row td {\n    margin: 0 !important;\n    padding: 7px !important;\n    //  vertical-align: middle !important;\n}\n\n.sticky_row input,\n.sticky_row select {\n    background-color: #f5f5f5;\n    color: black;\n    height: 35px;\n    width: 100%;\n}\n\n.hide_scrollbar::-webkit-scrollbar,\n.table_main_list::-webkit-scrollbar {\n    display: none !important;\n}\n\n.list_main_container {\n    padding: 0 30px 30px 30px !important;\n    background-color: white;\n    border-top: none;\n    border-left: 1px solid lightgray;\n    border-right: 1px solid lightgray;\n    border-bottom: 1px solid lightgray;\n    border-bottom-left-radius: 15px;\n    border-bottom-right-radius: 15px;\n    margin-bottom: 120px;\n    overflow: scroll;\n}\n\n.main_wrapper {\n    height: 90vh;\n    overflow-y: scroll;\n}\n\n.form_main_container {\n    max-height: 95vh;\n    overflow: scroll;\n    padding-bottom: 100px;\n}\n\n\n.table {\n    width: auto;\n    table-layout: fixed;\n    border-collapse: collapse;\n    background-color: white;\n    border-top-left-radius: 9px !important;\n    min-width: 100%;\n}\n\n.table th,\n.table td {\n    border: 1px solid #ccc;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    position: relative;\n    text-align: center !important;\n    vertical-align: middle;\n}\n\n#table_form_row td,\n#table_form_row td,\n#table_form_row td input,\n#table_form_row td select {\n    font-weight: bold !important;\n    color: gray !important;\n    background-color: rgb(252, 250, 250);\n}\n\n.list_wrapper {\n    padding: 20px;\n    font-size: 14px;\n}\n\n.list_wrapper .row:hover {\n    background-color: #f8fafc;\n}\n\n.list_wrapper .row .col,\n.list_wrapper .row .check_col {\n    border-bottom: 1px solid #e7e8ea;\n    background-color: transparent;\n    color: gray;\n}\n\n.switch_btn_div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/*List style for PC */\n.table_main_list thead {\n    position: sticky;\n    top: -11px;\n    z-index: 3;\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.table_main_list th:nth-child(1) {\n    width: 70px;\n    border-top: 7px solid #548dff;\n    position: sticky;\n    left: -12px;\n    z-index: 4;\n}\n\n.table_main_list th:nth-child(2) {\n    border-top: 7px solid #548dff;\n    position: sticky;\n    left: 58px;\n    z-index: 4;\n    text-align: left !important;\n    cursor: pointer;\n}\n\n.table_main_list td:nth-child(1) {\n    position: sticky;\n    left: -12px;\n    z-index: 2;\n}\n\n.table_main_list td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n    margin-top: -4px;\n    margin-left: -20px;\n    height: 18px;\n    width: 18px;\n}\n\n.table_main_list td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n    background-color: #548dff !important;\n}\n\n\n.table_main_list #sticky_col0 {\n    position: sticky;\n    left: 58px;\n    z-index: 2;\n\n}\n\n.table_main_list th:last-child {\n    width: 60px;\n}\n\n.table_main_list th,\n.table_main_list td {\n    width: 120px;\n    font-size: 12px;\n    color: gray !important;\n}\n\n\n/* List style for Mobile */\n.table_main_list_mobile thead {\n    position: sticky;\n    top: -4px;\n    z-index: 3;\n    background-color: white;\n\n}\n\n.table_main_list_mobile th:nth-child(1) {\n    width: 70px;\n    border-top: 7px solid #548dff;\n    /* position: sticky;\n   left: -2px; */\n}\n\n.table_main_list_mobile th:nth-child(2) {\n    width: 24;\n    border-top: 7px solid #548dff;\n    text-align: left !important;\n    /* position: sticky;\n   left: 67px; */\n}\n\n.table_main_list_mobile td:nth-child(1) {\n    /* position: sticky;;\n   left: -2px;\n   z-index: 2; */\n}\n\n.table_main_list_mobile #sticky_col0 {\n    /* position: sticky;\n   left: 67px;\n   z-index: 2; */\n\n}\n\n.table_main_list_mobile th:last-child,\n.table_main_list_mobile td:last-child {\n    width: 60px;\n    position: sticky;\n    // right: -20px;\n    background-color: rgb(245, 241, 241);\n}\n\n.table_main_list_mobile th,\n.table_main_list_mobile td {\n    width: 120px;\n    font-size: 12px;\n    color: gray !important;\n}\n\n.list_img {\n    height: 30px;\n    width: 30px;\n}\n\n.name_sec ._name {\n    color: #606175 !important;\n    font-size: 16px !important;\n    font-weight: 500;\n}\n\n.name_sec ._id {\n    color: #9a9ca8 !important;\n    font-size: 12px !important;\n}\n\n// Topbar \n\n.topbar_logo {\n    height: 40px;\n    width: auto;\n}\n\n.topbar_main {\n    height: 55px;\n    background-color: white;\n    border-bottom: 1px solid lightgray;\n}\n\n.esearch_wrapper input,\n.efilter_wrapper input {\n    height: 30px !important;\n    width: 20px !important;\n    background-color: #fbfcff;\n    color: #aaaaaa !important;\n    border: none;\n    font-size: 12px;\n}\n\n.esearch_wrapper input {\n    border-right: none !important;\n    border-top-right-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;\n}\n\n.efilter_wrapper input {\n    border-top-left-radius: 0px !important;\n    border-bottom-left-radius: 0px !important;\n}\n\n.esearch_wrapper input:focus,\n.efilter_wrapper input:focus {\n    background-color: #fbfcff;\n    border: none !important;\n    color: #aaaaaa;\n}\n\n.esearch_wrapper .esearch_span,\n.efilter_wrapper .efilter_span {\n    height: 30px !important;\n    border: none !important;\n    background-color: #fbfcff;\n    border: none;\n}\n\n.esearch_wrapper .esearch_span {\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n}\n\n.css-1e6y48t-MuiButtonBase-root-MuiButton-root,\n.css-1w1rijm-MuiButtonBase-root-MuiButton-root {\n    min-width: 0px;\n}\n\n.efilter_wrapper .efilter_span {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n}\n\n.add_event_btn {\n    width: 330px !important;\n    text-transform: capitalize;\n    font-size: 12px !important;\n}\n\n.filter_sec .view_type {\n    border-left: 1px solid lightgray;\n}\n\n.grid_view_row {\n    height: 80vh;\n    overflow-y: scroll;\n}\n\n.grid_view_row::-webkit-scrollbar {\n    display: none;\n}\n\n.event_tab_container {\n    background-color: white;\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n    border: 1px solid lightgray;\n\n}\n\n.css-1a4cg4j-MuiButtonBase-root-MuiTab-root {\n    margin-bottom: 7px;\n}\n\n.css-8je8zh-MuiTouchRipple-root {\n    border-right: 1px solid lightgray;\n}\n\n// .css-1a4cg4j-MuiButtonBase-root-MuiTab-root.Mui-selected {\n//     color: #548dff !important;\n// }\n\n.events_list {\n    height: 87vh !important;\n    padding-left: 20px;\n    padding-right: 20px;\n    overflow-y: scroll;\n}\n\n.events_list::-webkit-scrollbar {\n    display: none;\n}\n\n.events_grid_container {\n    background-color: white;\n    padding: 20px 30px 20px 30px;\n    margin-bottom: 150px;\n    border-left: 1px solid lightgray;\n    border-right: 1px solid lightgray;\n    border-bottom: 1px solid lightgray;\n    border-bottom-left-radius: 15px;\n    border-bottom-right-radius: 15px;\n}\n\n.css-1uz47yx-MuiPaper-root-MuiCard-root {\n    overflow: visible;\n}\n\n.event_info_container {\n    min-height: 180px;\n    height: auto;\n    background-color: white;\n    border-radius: 15px;\n    border: 1px solid lightgray;\n}\n\n.apply_border {\n    border-right: 1px solid lightgray;\n    // height: 100% !important;\n    // width: 100% !important;\n}\n\n.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n    background-color: #ddebff;\n    color: #579aff;\n    width: 40px;\n}\n\n.event_details_container1 {\n    min-height: 180px;\n    height: auto;\n}\n\n.event_details_container1 .detail_row1 {\n    min-height: 180px;\n    height: auto;\n}\n\n.detail_row1 .col1_contents,\n.detail_row1 .col2_contents,\n.detail_row1 .col3_contents {\n    border: 1px solid lightgray;\n    border-radius: 15px;\n    background-color: white;\n}\n\n.overview_grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr;\n}\n\n.list_main_wrapper {\n    height: 60vh;\n    overflow: scroll;\n}\n\n.list_main_wrapper::-webkit-scrollbar {\n    display: none;\n    margin-bottom: 100px;\n}\n\n#sticky_col11 {\n    width: 180px !important;\n}\n\n.custome_badge1 {\n    min-height: 20px;\n    width: auto;\n    border-radius: 30px;\n    background-color: #ffefef;\n}\n\n.custome_badge2 {\n    min-height: 20px;\n    width: auto;\n    border-radius: 30px;\n    background-color: #fff9eb;\n}\n\n.custome_badge3 {\n    min-height: 20px;\n    width: auto;\n    border-radius: 30px;\n    background-color: #edf5ff;\n}\n\n.candidate_details_container {\n    height: 80vh;\n    height: auto;\n    border: 1px solid lightgray;\n    border-radius: 15px;\n    background-color: white;\n}\n\n.candidate_details_container ._input_form {\n    padding: 0px 200px 30px 200px;\n}\n\n.candidate_main_container {\n    height: 87vh;\n    padding-bottom: 200px;\n    overflow: scroll;\n}\n\n.candidate_main_container::-webkit-scrollbar {\n    display: none;\n}\n\n.other_files_box {\n    height: 150px;\n    width: 200px;\n    border: 1px solid lightgray;\n    border-radius: 15px;\n}\n\n.candidate_details_sec1 {\n    border-bottom: 1px solid lightgray;\n}\n\n.scrollable_list_card_wrapper .css-1fua316-MuiPaper-root-MuiCard-root {\n    overflow: visible;\n}\n\n.scrollable_list_card_wrapper .css-1oitmrd-MuiButtonBase-root-MuiCardActionArea-root {\n    min-width: 768px;\n}\n\n.scrollable_list_card_wrapper .scrollable_card {\n    overflow-x: scroll;\n}\n\n.scrollable_list_card_wrapper .scrollable_card::-webkit-scrollbar {\n    display: none;\n}\n\n.main_container {\n    padding: 0px 40px 0px 40px;\n}\n\n\n\n\n.blue_theme_pagination .items_per_page_select {\n    border: none;\n    width: 55px;\n}\n\n.blue_theme_pagination .items_per_page_select:focus {\n    border: none;\n    outline: none;\n}\n\n.blue_theme_pagination .items_per_page_select option:hover {\n    background-color: #548dff;\n    color: white;\n}\n\n\n\n@media screen and (max-width : 991px) {\n    .candidate_details_container ._input_form {\n        padding: 0px 50px 20px 50px;\n    }\n}\n\n@media screen and (max-width : 583px) {\n    ._cont1 {\n        font-size: 16px;\n    }\n\n    ._cont2 {\n        font-size: 14px;\n    }\n\n    ._cont3 {\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width : 576px) {\n    .pc_display {\n        display: none !important;\n    }\n\n    .mobile_display {\n        display: block !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
